<template>
  <div class="new-home-con">
    <div class="el-carousel__item u070db_3"></div>
    <div class="new-home-wrap">
      <Header :fontColor="'#fff'"></Header>
      <div class="new-home-search">
        <!-- 贸易 -->
        <div id="g28c69" class="new-search-country-con">
          <div id="gc1d8d" class="new-search-country-con-Home">
            <div
              class="trade-dropdown"
              @click.stop="isTradeShow = !isTradeShow"
            >
              <span class="select-country-con">
                <span class="select-country-name">{{
                  selectTradeObj.Name
                }}</span>
                <i
                  class="iconfont icon-jiantouxia"
                  :class="{ 'country-arrow': isTradeShow }"
                ></i>
              </span>
            </div>
            <div
              class="trade-popper"
              :class="{ 'trade-show-popper': isTradeShow }"
            >
              <div
                class="trade-item-con"
                v-for="(item, index) in tradeList"
                :key="index"
                :class="{
                  activeTrade: selectTradeObj.Code == item.Code,
                }"
                @click="onSelectTrade(item.Code, item.Name)"
              >
                {{ item.Name }}
              </div>
            </div>
            <el-autocomplete
              id="c308fb"
              clearable
              v-model="searchStr"
              style="flex: 1; height: auto"
              :highlight-first-item="true"
              ref="TradeInput"
              :debounce="300"
              :trigger-on-focus="false"
              :autofocus="true"
              class="search-country-input"
              @select="handleSelect"
              :fetch-suggestions="querySearchAsync"
              :placeholder="placeholderTrade"
              size="large"
              popper-class="trade_auto_sel_box"
            >
            </el-autocomplete>

            <el-button type="primary" round class="search-country-btn NewsBack"
              ><i class="iconfont icon-search"></i>Search</el-button
            >
          </div>
        </div>
        <div class="new-home-search-text">
          Transform global trade data into strategic market insights
        </div>
      </div>
      <!-- 新闻推荐 -->
      <Newsrecommendation></Newsrecommendation>
    </div>
  </div>
</template>
<script>
import {
  getqueryList,
  getNotificationList,
  markAllAsRead,
  getqueryaddList,
  getqueryremoveList,
  companyView,
} from "@/api/userApi";
import { LoginOut } from "@/api/api.js";
import bus from "../../components/bus";
import { mixins1 } from "../../mixins/index";
import Header from "@/views/newLayout/header.vue";
import Newsrecommendation from "./Newsrecommendation.vue";
//importEnd
import { getCountryCollection, getUserSimpleInfo } from "@/api/companyApi.js";
import {
  searchCompany,
  productSearch,
  searchTradeHscode,
} from "@/api/searchApi.js";
import OperationWarning from "@/components/power/OperationWarning.vue";
import { mapGetters } from "vuex";
export default {
  mixins: [mixins1],
  name: "",
  props: {},

  components: {
    Header,
    // OperationWarning,
    Newsrecommendation,
  },
  created() {
    //登陆状态
    this.token ? (this.loginStatus = true) : (this.loginStatus = false);
    //登陆状态
    bus.$on("handleLogin", (loginCheck) => {
      // location.reload();
      this.loginStatus = loginCheck;
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.imageUrl =
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg;
      this.getUserSimpleInfoList();
      this.getqueryListDetale();
      this.getNotificationListDetali();
    });
    if (this.token) {
      this.companyViewPower();

      this.getUserSimpleInfoList();
      this.getqueryListDetale();
      this.getNotificationListDetali();
      this.imageUrl =
        JSON.parse(localStorage.getItem("userInfoImg")) == undefined
          ? this.imageUrl
          : JSON.parse(localStorage.getItem("userInfoImg"));
    }
  },
  mounted() {
    this.getAllCountry();
    this.selectLanguage({ countryCode: this.$store.state.app.lang });
    this.$i18n.locale = this.$store.state.app.lang;
    this.$store.dispatch("app/setLang", this.$i18n.locale);
    document.querySelector("html").classList.add("html-new-page");
  },

  data() {
    return {
      Keyword: true,
      drawer: false,
      hasPrivilege: false,
      items: [1, 2, 3, 4, 5],
      activeIndex: 0,
      swiperOption: {
        slidesPerView: 10,
        centeredSlides: true,
        //居中幻灯片无缺口。当你通过设置 centeredSlides: true 使得幻灯片居中后，
        centeredSlidesBounds: true,
        normalizeSlideIndex: false,

        direction: "vertical",
        spaceBetween: 0,
        // 滑动速度
        speed: 800,
        autoplay: {
          //自动开始
          delay: 3000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        // 无限循环
        loop: true,
        observer: false,
        observeParents: false,
      },
      Newlist: [],
      RedNews: [],
      ExpireDate: "",
      Vips: [],
      searchStr: "",
      AvailablePoints: 0,
      lockType: 0,
      percentage: 0,

      // isShowChannel
      isShowChannel: false,
      tradeSelect: "HsCode",
      placeholder: "Enter company name",
      countryImg: "",
      tabCountryList: [],
      countryCode: "",
      countryCode1: "",
      countryName: "", //选中国家
      tabActiveName: "", //选择的区域
      placeholderTrade: "Search by",
      headPortrait: false,
      languageList: [
        {
          countryCode: "en",
          countryCodeImg: "GB",
          countryName: "English",
          color: true,
        },
        {
          countryCode: "jp",
          countryCodeImg: "JP",
          countryName: "Japanese",
          color: false,
        },
        {
          countryCode: "de",
          countryCodeImg: "DE",
          countryName: "German",
        },
        {
          countryCode: "fr",
          countryCodeImg: "FR",
          countryName: "France",
        },

        {
          countryCode: "es",
          countryCodeImg: "ES",
          countryName: "Spain",
        },
        {
          countryCode: "it",
          countryCodeImg: "IT",
          countryName: "Italy",
        },
        {
          countryCode: "nl",
          countryCodeImg: "NL",
          countryName: "Netherlands",
        },
        {
          countryCode: "pt",
          countryCodeImg: "PT",
          countryName: "Portugal",
        },
      ],
      // existingList
      existingList: [],
      // paidList
      paidList: [],
      // followingName
      followingName: "explore",
      // favoritesList
      favoritesList: [
        {
          name: "By letter",
          id: "blet",
          isActive: false,
        },
        {
          name: "By size",
          id: "bsz",
          isActive: false,
        },
        {
          name: "By category",
          id: "bct",
          isActive: true,
        },
        {
          name: "By date",
          id: "bd",
          isActive: false,
        },
        {
          name: "By status",
          id: "bst",
          isActive: false,
        },
      ],
      // activeFavoritesId
      activeFavoritesId: "",
      //
      isTradeShow: false,
      selectTradeObj: {
        Code: "HsCode",
        Name: "Product",
      },
      tradeList: [
        {
          Code: "HsCode",
          Name: "Product",
        },
        {
          Code: "Company",
          Name: "Company",
        },
        {
          Code: "Country",
          Name: "Country",
        },
      ],
      isShowChat: false,
      loginDialog: false, //登录弹框
      loginStatus: false, //登录状态,
      Perfectdatalog: false, //收集信息
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
      token: localStorage.getItem("token"),
      userRole: {},
      percentageerr: false,

      moreclose: false,
      restaurants: [],
      state: "",
      timeout: null,
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,

      // srcviewshomeindexvueDataEnd
    };
  },
  methods: {
    selectLanguage(item) {
      this.languageList.map((ite) => {
        if (ite.countryCode == item.countryCode) {
          ite.color = true;
        } else {
          ite.color = false;
        }
      });
      this.$i18n.locale = item.countryCode;
      sessionStorage.setItem("language", this.$i18n.locale);

      this.$store.dispatch("app/setLang", this.$i18n.locale);
    },
    companyViewPower() {
      companyView({}).then((res) => {
        if (!res.data) {
          this.$store.dispatch("app/SetOperationWarning", true);
          // this.$bus.$emit('show-OperationWaring-dialog', '');
        }
      });
    },
    OperationWarningShow() {
      this.$bus.$emit("show-OperationWaring-dialog", "");
    },
    // 九宫格
    clossuoDialog(value) {
      this.drawer = value;
    },
    gotccsibizinfo(value) {
      window.open(value, "_blank");
    },
    // onSlideChange($event) {
    // },
    beforeEnter(el) {
      el.classList.add("active");
    },
    leave(el) {
      el.classList.remove("active");
    },
    labelClick(label) {
      this.countryName = label;
    },
    //清除选择的国家
    clearCountry() {
      this.countryImg = "";
      this.countryCode = "";
      this.countryCode1 = "";
    },
    selectCountry(val) {
      let countryImg = this.getCountryImgUrl(val);
      let flag = require("../../../static" + countryImg);
      this.countryImg = flag;
      this.countryCode = val;

      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == val) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
    },
    //切换keyword
    switchHeadKeyword() {
      this.isKeyword != this.isKeyword;
    },
    // 贸易模糊搜索
    querySearchAsync(queryString, cb) {
      //  this.$refs.TradeInput.suggestionVisible=false
      if (!this.loginStatus) {
        this.loginDialog = true;
        cb([]);
      } else {
        if (queryString !== "") {
          if (this.tradeSelect == "HsCode") {
            const params = {
              keyword: queryString,
            };
            productSearch(params)
              .then((res) => {
                const data = res.data;
                if (res.code) {
                  data.forEach((item) => {
                    item.val = item.hsCode;
                    item.value = item.hsCode + "-" + item.hsCodeDescription;

                    // item.val=item.value
                  });

                  cb(data);
                } else {
                  cb([]);
                }
              })
              .catch(() => {
                cb([]);
              });
          }
          if (this.tradeSelect == "Company") {
            const params = {
              company_name: queryString,
              page: 1,
              pageSize: 100,
              ieflag: 1,
            };
            searchCompany(params)
              .then((res) => {
                const data = res.data;
                if (res.code) {
                  data.rows.forEach((item) => {
                    item.val = item.aaa_id;
                    item.value = item.company_name_en;
                    // item.val=item.value
                  });
                  cb(data.rows);
                } else {
                  cb([]);
                }
              })
              .catch(() => {
                cb([]);
              });
          }
          if (this.tradeSelect == "Country") {
            let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0]
              .countryList;
            Allcountry.forEach((item) => {
              item.value = item.nameEn;
              item.val = item.countryCode;
            });
            let SelecrCountry = queryString
              ? Allcountry.filter(this.createStateFilter(queryString))
              : Allcountry;
            cb(SelecrCountry);
          }
        }
      }
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    // 选择贸易频道
    onSelectTrade(code, name) {
      this.searchStr = "";
      this.tradeSelect = code;
      this.selectTradeObj.Code = code;
      this.selectTradeObj.Name = name;
      this.isTradeShow = false;
    },
    // 搜索下拉

    handleSelect(item) {
      let SACode1 = "";
      if (this.tradeSelect == "Company") {
        sessionStorage.setItem("company", JSON.stringify(item));
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
          .countryList;

        newscountry.map((ite) => {
          if (ite.countryCode == item.company_country) {
            SACode1 = ite.dowjonesCountrycode;
          }
        });
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/details
          path:
            "/index/tradeCompany/Trade/" +
            item.aaa_id +
            // "/background/snapshot?id3a=" +
            "/tradeMap/map?id3a=" +
            item.aaa_id +
            "&companyCountry=" +
            item.company_country +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            item.company_name_en +
            "&Tradechannel=" +
            this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
      }
      if (this.tradeSelect == "HsCode") {
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/details
          path:
            "/index/TradeProduct/TradeDetail/" +
            item.hsCode +
            // "/background/snapshot?id3a=" +
            "/tradeMap/map?id3a=" +
            item.hsCode +
            "&Tradechannel=" +
            this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
      }
      if (this.tradeSelect == "Country") {
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/details
          path:
            "/index/TradeCountry/TradeDetail/" +
            item.countryCode +
            // "/background/snapshot?id3a=" +
            "/tradeMap/map?id3a=" +
            item.countryCode +
            "&Tradechannel=" +
            this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");
      }
    },

    gotomessage(item) {
      this.$router.push({
        path: "/account/Notifications",
        query: {
          id: item.id,
        },
      });
    },
    isShowChannelmethad() {
      this.isShowChannel = true;
    },
    async getAllCountry() {
      let countryCode = "";
      // localStorage.setItem('countryList',JSON.stringify(countryImgList))
      // 处理缓存问题

      if (JSON.parse(localStorage.getItem("countryList"))) {
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        let list = this.tabCountryList;
        list.forEach((item, index) => {
          item.countryList.forEach((it) => {
            let countryImg = "";
            if (it.urlBanner == null) {
              countryImg = "../../../static/imagev2/zanwutupian.png";
            } else {
              countryImg = it.urlBanner.split("../../../static")[1];
            }
            // let flag = require('../../static' + countryImg);
            let flag = "";
            try {
              flag = require("../../../static" + countryImg);
            } catch (error) {
              flag = "../../../static/imagev2/undefined.png";
              // 提供一个默认值或者其他处理方式
              // flag = require("../../../static" + countryImg);
            }
            it.urlBanner = flag;
            if (countryCode && it.countryCode == countryCode) {
              this.countryName = it.nameEn;
              this.countryImg = it.urlBanner;
            }
          });
        });
      } else {
        // 清理缓存后重新请求页面
        let res = await getCountryCollection();

        if (res && res.code) {
          let countryImgList = res.data.rows;
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList"),
          ); //res.data.rows
          this.tabCountryList =
            JSON.parse(localStorage.getItem("countryList")) == null
              ? res.data.rows
              : JSON.parse(localStorage.getItem("countryList"));

          localStorage.setItem("countryList", JSON.stringify(countryImgList));

          let list = this.tabCountryList;

          list.forEach((item, index) => {
            item.countryList.forEach((it) => {
              let countryImg = "";
              // /imagev2/zanwutupian.png
              if (it.urlBanner == null) {
                countryImg = "../../../static/imagev2/zanwutupian.png";
              } else {
                countryImg = it.urlBanner.split("../../../static")[1];
              }
              // let flag = require('../../static' + countryImg);
              let flag = "";
              try {
                flag = require("../../../static" + countryImg);
              } catch (error) {
                flag = require("../../../static/imagev2/undefined.png");
                // 提供一个默认值或者其他处理方式
                // flag = require("../../../static" + countryImg);
              }
              it.urlBanner = flag;
              if (countryCode && it.countryCode == countryCode) {
                this.countryName = it.nameEn;
                this.countryImg = it.urlBanner;
              }
            });
          });
        }
      }
    },
    AIseach() {
      if (this.loginStatus) {
        if (this.lockType == 2 || this.lockType == 3) {
          this.isShowChat = !this.isShowChat;
        } else {
          this.hasPrivilege = true;
        }
      } else {
        this.loginDialog = true;
      }
    },
    chasPrivilegeDialog() {
      this.hasPrivilege = false;
    },
    hide(value) {
      this.isShowChat = value;
    },
    MarkRead() {
      markAllAsRead().then((res) => {
        if (res.code == 200) {
          this.getNotificationListDetali();
          this.RedNews.length = 0;
        }
      });
    },

    // 信息获取
    getNotificationListDetali() {
      getNotificationList().then((res) => {
        if (res.code == 200) {
          this.Newlist = res.data;
          if (this.Newlist.length > 0) {
            res.data.map((item) => {
              if (item.hasRead == 0) {
                this.RedNews.push(item);
              }
            });
          }
        } else {
          this.Newlist = [];
        }
      });
    },
    // 积分获取
    getUserSimpleInfoList() {
      getUserSimpleInfo().then((res) => {
        if (res.code == 200) {
          if (res.data.certification != 1) {
            localStorage.setItem("renzheng", true);
          }
          this.AvailablePoints = res.data.availablePoints;
          this.ExpireDate = res.data.expiration;
          this.Vips = res.data.vips;
          this.lockType = res.data.lockType;
          this.$store.dispatch("app/setEquityType", res.data.availablePoints);
        }
      });
    },
    getqueryListDetale() {
      getqueryList().then((res) => {
        if (res.code == 200) {
          let showList = [];
          let showListtwo = [];
          res.data.forEach((item) => {
            showList.push({
              id: item.moduleId,
              name: item.screenName,
              type: item.screenName,
              isSelect: item.isShow,
              icon: item.icon,
            });
            if (item.isShow == true) {
              showListtwo.push({
                id: item.moduleId,
                name: item.screenName,
                type: item.screenName,
                isSelect: item.isShow,
                icon: item.icon,
              });
            }
          });
          this.existingList = showList;

          this.paidList = showListtwo;
        }
      });
    },

    gotoUSer(route) {
      this.$router.push({
        path: route,
      });
    },
    // insertMethod
    // srcviewshomeindexvueMethodStart
    // default
    Sign() {
      this.loginDialog = true;
    },

    default() {}, // 跳转搜索列表页面
    openList(str) {
      this.$store.dispatch("app/SetlabelCode", "");
      this.$store.dispatch("app/SetlabelCodeName", "");
      let Keyword = "";

      if (this.Keyword) {
        Keyword = 2;
      } else {
        Keyword = 1;
      }
      if (str) {
        this.$store.commit("setRefreshKey", new Date().getTime());
        this.$router.push({
          path: "/index/search/list/" + str + "/company",
          query: {
            searchname: str,
            companyCountry: this.countryCode,
            keword: Keyword,
          },
        });
      } else {
        // this.$router.push({
        //   path: "index/list/company",
        // });
      }
    }, // deleteTool
    deleteTool(item) {
      let index = this.existingList.findIndex((item2) => item2.id == item.id);
      let paidListindex = this.paidList.findIndex(
        (item3) => item3.id == item.id,
      );

      this.existingList[index].isSelect = false;

      if (index !== -1) {
        getqueryremoveList({
          moduleId: item.id,
        }).then((res) => {});
        this.paidList.splice(paidListindex, 1);
      }
      // item.isSelect = false;
    }, // addTool
    addTool(item) {
      let obj = this.existingList.find((item2) => item2.id == item.id);
      if (item.isSelect == false) {
        item.isSelect = true;
        getqueryaddList({
          moduleId: item.id,
        }).then((res) => {});
        this.paidList.push(JSON.parse(JSON.stringify(item)));
      }
    }, // taggleFlolwing
    taggleFlolwing(name) {
      this.followingName = name;
    },
    //Sign out 登出
    signOutAccount() {
      LoginOut({}).then((res) => {
        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });

          bus.$off("handleLogin");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          location.reload();
          // window.location.href = "/";
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("dataCleaningField");
          location.reload();
          // window.location.href = "/";
        }
      });
    },

    gotoOne(value) {
      window.open(value, "_blank");
    },
    goHome() {
      this.$router.push("/");
    },
    // srcviewshomeindexvueMethodEnd
  },

  computed: {
    ...mapGetters({
      lang: "app/lang",
    }),
    classOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        // limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style scoped>
.new-home-con .el-carousel {
  height: 100%;
}

.new-home-con >>> .el-carousel__container {
  height: 100%;
}

.new-home-con >>> .el-carousel__item {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.new-home-con >>> .el-carousel__indicators--horizontal {
  display: flex;
  align-items: center;
  height: 8px;
  bottom: 3%;
}

.new-home-con >>> .el-carousel__indicator {
  padding: 0;
}

.new-home-con >>> .el-carousel__indicator:not(:last-child) {
  margin-right: 6px;
}

.new-home-con >>> .el-carousel__button {
  width: 8px;
  height: 8px;
  opacity: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.51);
}

.new-home-con >>> .el-carousel__indicator.is-active .el-carousel__button {
  background: rgba(255, 255, 255, 1);
}

.new-home-con .new-home-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 7vh);
  z-index: 2;
}

.new-home-search-text {
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.8);
  text-align: center;
}

.new-home-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 82.709%;
}

.new-home-title {
  width: calc(100% - 40px);
  height: 88px;
  margin: 0 auto;
  line-height: 88px;
  padding-left: 20px;
  font-weight: 400;
  font-size: 34px;
  color: #ffffff;
  text-shadow: 0px 2px 2px rgba(6, 59, 64, 0.5);
  background: rgba(105, 128, 146, 0.45);
  border-radius: 6px;
  backdrop-filter: blur(8px);
}

.new-home-bottom-card {
  display: flex;
  height: 352px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
}

.new-home-card-left,
.new-home-card-middle {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.new-home-card-left {
  position: relative;
  padding-left: 50px;
  background: #1290c9;
}

.new-home-card-left img {
  position: absolute;
  top: 110px;
  left: 14px;
  width: 22px;
  height: 16px;
}

.new-home-card-left .slider-box {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.new-home-card-left .slider-con {
  display: flex;
  flex-direction: column;
  /* 内容排列为竖直方向 */
  padding-top: 14px;
  animation: scrollTop 25s linear infinite;
  will-change: transform;
}

@keyframes scrollTop {
  0% {
    transform: translateY(0);
    /* 初始位置 */
  }

  100% {
    transform: translateY(-47%);
  }
}

.new-home-card-left .slider-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  font-weight: bold;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
  transition: 0.5s ease-in-out !important;
  cursor: pointer;
}

.new-home-card-left .slider-item.active {
  font-size: 24px;
  color: #ffffff;
}

.new-home-card-left .slider-item:not(:last-child) {
  margin-bottom: 2px;
}

.new-home-card-middle {
  position: relative;
  margin: 0 14px;
  background-position: left center;
  background-size: cover;
  overflow: hidden;
}

.new-home-middle-img {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate3d(-42%, 0%, 0);
  max-width: none;
  width: 703px;
  height: 399px;
  background-position: center center;
  background-size: cover;
  /* will-change: transform; */
  animation: scrollImg 12s linear infinite alternate;
}

@keyframes scrollImg {
  0% {
    transform: translate3d(-42%, 0%, 0);
  }

  50% {
    transform: translate3d(-50%, 0%, 0);
  }

  100% {
    transform: translate3d(-58%, 0%, 0);
  }
}

.new-home-middle-text {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px 20px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  text-align: justify;
  cursor: pointer;
}

.new-home-middle-text:hover {
  text-decoration: underline;
}

.new-home-card-right {
  width: 300px;
  padding: 40px 10px 0 10px;
  background: #f5f5f5;
  border-radius: 12px;
}

.new-home-right-img {
  width: 120px;
  height: 120px;
  padding: 3px;
  margin: 0 auto 16px auto;
  background: #ffffff;
}

.new-home-right-text {
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
}

.new-search-country-con-Home {
  display: flex;
  align-items: center;
  width: 100%;
}

/* 国家搜索 */
.country_flag {
  display: flex;
  align-items: center;
  width: 46px;
  padding-left: 15px;
}

.country_flag_img {
  width: 100%;
  height: auto;
}

.sel_value {
  width: 4.571428571428571rem;
  font-size: 1rem;
  word-break: break-all;
}

.search_sel_container /deep/ .el-tabs__active-bar {
  display: none;
}

.search_sel_container .right {
  width: 68.5rem;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  max-height: 24.285714285714285rem;
  align-content: flex-start;
  margin-right: 0.07142857142857142rem;
  padding: 0 0.571428571428571rem;
  overflow: auto;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
  height: 3rem;
  display: flex;
  align-items: center;
}

.search_sel_container /deep/ .el-tabs__item.is-left.is-active {
  background: #f5f5f5;
}

.el-select-dropdown__item:hover {
  background: #f5f5f5;
}

.search_sel_container /deep/ .el-tabs__item:hover {
  color: #1290c9;
  font-weight: normal;
}

.search_sel_container .left_txt {
  font-size: 14px;
  margin-right: 10px;
}

.search_sel_container .right .el-select-dropdown__item {
  width: 15.857142857142858rem;
  height: 4rem;
  padding: 0 0.7142857142857143rem;
  margin: 0.3542857142857143rem 0.35714285714285715rem;
  border: 0.07142857142857142rem solid #fff;
  background: #f5f5f5;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected,
.search_sel_container .right /deep/ .el-select-dropdown__item.hover {
  background: #f5f5f5;
  /* border-radius: 1rem; */
  border: 1px solid #1290c9;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected {
  color: #022955;
  font-weight: normal;
}

.right_item {
  height: 100%;
  width: 100%;
}

.search_sel_container .right .img {
  width: 3.857142857142857rem;
  height: 100%;
  margin-right: 0.35714285714285715rem;
}

.search_sel_container .right .rBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.search_sel_container .right .rBox .coun_title {
  font-size: 1.142857rem;
  line-height: 1;
  margin-bottom: 0.2857142857142857rem;
  max-width: 10rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.seamless-warp {
  overflow: hidden;
  width: 100%;
  color: white;
  font-size: 18px;
  text-align: center;
}

.timeline {
  height: 80%;
}

.botton_left_text {
  background: #1290c9;
  border-radius: 12px 12px;
  height: 100%;
  width: 100%;
  padding-left: 2.428rem;
}

/deep/.swiper-container {
  height: 21.4285714rem;
}

.slide-text {
  text-align: center;
  font-size: 1.14285714rem;
  color: #666;
  transition: all 0.3s;
}

/deep/ .swiper-slide {
  width: 100% !important;
  text-align: left !important;
  height: 2.14285714rem !important;
  font-size: 1.2857143rem;
  line-height: 2.14285714rem;
  transition: transform 0.3s, color 0.3s;
  padding-left: 5px;
  color: #f4f4f44d;
  transition: 0.5s ease-in-out !important;
  font-family: "Arial";
}

/deep/.swiper-slide-active {
  color: #f4f4f4 !important;
  font-size: 1.714285714rem !important;
  font-family: "Arial Bold";
}

.search-country-input {
  padding: 0 20px;
}

.search-country-input >>> .el-input__inner {
  line-height: 70px;
  font-size: 16px;
  padding: 0 0 0 10px !important;
  color: #1a2332;
  border: none !important;
  border-radius: 0;
}

.search-country-input >>> .el-input__inner::placeholder {
  font-weight: 400;
  color: #999;
}

.search-country-btn {
  position: relative;
  left: 1px;
  display: flex;
  align-items: center;
  width: 150px;
  height: 70px;
  font-size: 18px;
  color: #ffffff;
  background: #009ea7;
  border-radius: 0px 35px 35px 0px;
}

.search-country-btn >>> span {
  display: flex;
  align-items: center;
}

.search-country-btn i {
  font-size: 40px;
}

.select-country-con {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 14px 0 20px;
  cursor: pointer;
}

.select-country-con .country-placeholder {
  flex: 1;
  font-size: 16px;
}

.select-country-con i {
  font-size: 16px;
  color: #1a2332;
  transition: all 0.3s;
}
.search-country-input >>> .el-input__inner {
  padding: 0 0 0 20px !important;
}

.u070db_3 {
  background: url("../../assets/images/0-2Trame.jpg") no-repeat;
}

.u070db_4 {
  background: url("../../assets/images/0-5home.jpg") no-repeat;
}

.u070db_5 {
  background: url("../../assets/images/0-4home.jpg") no-repeat;
}

::v-deep .el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: transparent;
}

.NewsBack {
  background-color: #009ea7 !important;
}

.trade_auto_sel_box.el-autocomplete-suggestion li {
  font-size: 16px;
}

.trade-dropdown {
  position: relative;
  width: 210px;
  border-radius: 27px 0 0 27px;
  margin-right: 0;
}
.trade-dropdown::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}
.trade-item-con:hover,
.trade-item-con.activeTrade {
  background: #f5f5f5;
  color: #009ea7;
}
.select-country-name {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-right: 6px;
  line-height: 20px;
  font-size: 16px;
  color: #1a2332;
  overflow: hidden;
}
.trade-popper {
  position: absolute;
  top: 78px;
  left: 0;
  width: 200px;
  height: auto;
  padding: 12px 0;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  z-index: -1;
  opacity: 0;
  transform: perspective(300px) rotateX(-10deg);
  transform-origin: 50% 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.trade-show-popper {
  opacity: 1;
  z-index: 2000;
  pointer-events: all;
  transform: rotateX(0deg);
}

.trade-item-con {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  font-size: 20px;
  color: #1a2332;
  cursor: pointer;
}

.trade-item-con:not(:last-child) {
  margin-bottom: 4px;
}
.trade_auto_sel_box li.highlighted {
  background: #f5f5f5;
  color: #009ea7;
}
.trade_auto_sel_box.el-autocomplete-suggestion li {
  font-size: 16px;
}

@media (max-width: 1920px) {
  .new-home-search-text {
    font-size: 14px;
    line-height: 20px;
  }

  .new-home-title {
    width: calc(100% - 26px);
    height: 58px;
    line-height: 58px;
    padding-left: 14px;
    font-size: 22px;
    border-radius: 5px;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
  }

  .new-home-bottom-card {
    height: 235px;
    padding: 14px;
    border-radius: 8px;
  }

  .new-home-card-left {
    padding-left: 35px;
  }

  .new-home-card-left img {
    top: 74px;
    left: 10px;
    width: 15px;
    height: auto;
  }

  .new-home-card-left .slider-con {
    padding-top: 10px;
  }

  .new-home-card-left .slider-item {
    height: 18px;
    line-height: 18px;
    font-size: 14px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 20px;
  }

  .new-home-card-left .slider-item:not(:last-child) {
    margin-bottom: 1px;
  }

  .new-home-card-middle {
    margin: 0 10px;
  }

  .new-home-middle-img {
    width: 468px;
    height: 266px;
    animation: scrollImg 15s linear infinite alternate;
  }

  .new-home-middle-text {
    padding: 20px 14px;
    font-size: 12px;
    line-height: 14px;
  }

  .new-home-card-right {
    width: 205px;
    padding: 26px 6px 0 6px;
    border-radius: 8px;
  }

  .new-home-right-img {
    width: 80px;
    height: 80px;
    padding: 2px;
    margin: 0 auto 10px auto;
  }

  .new-home-right-text {
    font-size: 12px;
    line-height: 14px;
  }

  .search-country-input {
    padding: 0 10px 0 0;
  }

  .search-country-input >>> .el-input__inner {
    line-height: 46px;
    font-size: 14px;
    padding: 0 0 0 10px !important;
  }

  .search-country-btn {
    width: 110px;
    height: 50px;
    padding: 0 0 0 10px;
    font-size: 14px;
    border-radius: 0px 26px 26px 0px;
  }

  .search-country-btn i {
    font-size: 26px;
    margin-right: 5px;
  }

  .select-country-con {
    padding: 0 10px 0 15px;
  }

  .page-top-con .select-country-con i {
    font-size: 12px;
  }

  .country_flag {
    width: 36px;
    padding-left: 10px;
  }

  .new-home-bottom {
    width: 1300px;
  }

  .trade_auto_sel_box.el-autocomplete-suggestion li {
    font-size: 14px;
  }
  .trade-dropdown {
    width: 160px;
    border-radius: 20px 0 0 20px;
  }

  .trade-dropdown::after {
    height: 22px;
  }
  .trade-dropdown .select-country-name {
    font-size: 14px;
  }
  .trade-popper {
    top: 58px;
    width: 160px;
    padding: 8px 0;
    border-radius: 4px;
  }
  .trade-item-con {
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    font-size: 16px;
  }

  .trade-item-con:not(:last-child) {
    margin-bottom: 2px;
  }
  .trade_auto_sel_box.el-autocomplete-suggestion li {
    font-size: 14px;
  }
}

@media screen and (max-width: 1439px) {
  .new-home-bottom {
    width: 1100px;
  }

  .trade_auto_sel_box /deep/ li {
    font-size: 14px;
    padding: 4px 15px;
    line-height: 26px;
  }
}
</style>
